import { Product } from './Product';
import { Unit } from './Unit';
import { Currency } from './Currency';

export interface SalesOrderDetail {
    id?: number;
    sales_order_id?: number;
    product_id?: number;
    quantity?: number;
    quantity_unit_id?: number;
    price?: number;
    price_currency_id?: number;
    price_unit_id?: number;
    position?: number;
    order_date?: string;
    destination_id?: number;
    is_active?: boolean;
    created_at?: string;
    updated_at?: string;
    // Campos del serializer All
    product?: string;
    quantity_unit?: string;
    price_currency?: string;
    price_currency_iso?: string;
    price_unit?: string;
    destination?: string;
}

export interface SalesOrderDetailDataForm {
    id?: number;
    sales_order_id?: number;
    product_id?: number;
    quantity?: number;
    quantity_unit_id?: number;
    price?: number;
    price_currency_id?: number;
    price_unit_id?: number;
    position?: number;
    order_date?: string;
    destination_id?: number;
}

export const defaultSalesOrderDetailDataForm: SalesOrderDetailDataForm = {
    sales_order_id: undefined,
    product_id: undefined,
    quantity: 0,
    quantity_unit_id: undefined,
    price: 0,
    price_currency_id: undefined,
    price_unit_id: undefined,
    position: 1,
    order_date: undefined,
    destination_id: undefined
};

export interface SalesOrderDetailFilters {
    page: number;
    per_page: number;
    sort: string;
    order: string;
    sales_order_id?: number;
    id?: string;
}

